if (typeof global === "undefined") {
  window.global = window;
}

import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { AuthProvider } from "./contexts/AuthContext.jsx";

import BackToTopFAB from "./components/BackToTopFAB/BackToTopFAB.jsx";
import GoogleMapsProvider from "./components/Map/GoogleMapsProvider.jsx";

import { UtilProvider } from "./contexts/UtilContext.jsx";
import { AppRouter } from "./routes.jsx";
// import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init({
  duration: 1000, // Animation duration (in milliseconds)
  easing: "ease-in-out", // Animation easing
  once: true, // Whether animation should happen only once
});

// Reinitialize AOS on React Router navigation
const ReinitializeAOS = () => {
  useEffect(() => {
    AOS.refresh(); // Reinitialize AOS when the component mounts
  }, []);
  return null;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <>
    <AuthProvider>
      <UtilProvider>
        <GoogleMapsProvider>
          <AppRouter />
        </GoogleMapsProvider>

        <ReinitializeAOS />
      </UtilProvider>
    </AuthProvider>
    <BackToTopFAB />
  </>

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
